export const updateSelectedReport = (log) => (dispatch) => {
  dispatch({
    type: 'UPDATE_ADMIN_REPORTING_PAGE_SELECTED_REPORT',
    payload: log
  });
};
